import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import api from '@/services/api';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import TextField from '@/components/Input/TextField';
import { Button } from '@/components/Button';
import { Mail } from 'lucide-react';
import { Caption, Title } from './style';
import { useTranslation } from 'react-i18next';

function StepOne() {
  const initialValues = {
    email: '',
  };
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  // Esquema de validação
  const RecoveryValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('forgetPassword.invalidEmail'))
      .required(t('forgetPassword.requireEmail'))
      .nonNullable(t('forgetPassword.notNull')),
  });

  const handleRecovery = async (values: { email: string }) => {
    try {
      const response = await api.post('/users/forgot-password', {
        email: values.email,
      });
      console.log(response);
      if (response.status === 204) {
        enqueueSnackbar(t('forgetPassword.checkInbox'), { variant: 'info' });
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          enqueueSnackbar(error.response.data?.detail, { variant: 'error' });
        }
      }
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={RecoveryValidationSchema}
      onSubmit={handleRecovery}
    >
      {({ values, touched, errors, handleChange, submitForm }) => (
        <>
          <div>
            <Title variant="h5">{t('forgetPassword.recoverPassword')}</Title>
            <Caption variant="caption">
              {t('forgetPassword.enterEmail')}
            </Caption>
          </div>
          <TextField
            placeholder="email@email.com"
            name="email"
            id="email"
            value={values.email}
            onChange={handleChange}
            error={touched.email && Boolean(errors.email)}
            helperText={<ErrorMessage name="email" component="div" />}
          />

          <Button
            variant="default"
            fullWidth={true}
            type="submit"
            onClick={submitForm}
            startIcon={<Mail />}
          >
            {t('forgetPassword.send')}
          </Button>
        </>
      )}
    </Formik>
  );
}

export default StepOne;
